import { useGameStore } from '~/stores/games.store';
import { useSiteStore } from '~/stores/site.store';
import type {
  IGameCategoriesV4Data,
  IGameCategoryResponse,
} from '~/interfaces/dto/games/response';
import type { IGameCategoriesRequest } from '~/interfaces/dto/games/request';

export const useCommonGaming = () => {
  const gameStore = useGameStore();
  const siteStore = useSiteStore();

  const { $gameService } = useServices();
  const route = useRoute();
  return { $gameService, route, gameStore, siteStore };
};

export const useGetVertical = async ({
  skipStateUpdate = false,
  freePlayOnly = false,
  count = 16,
  clearState = true,
} = {}): Promise<IGameCategoriesV4Data> => {
  const { getLocale } = useLocaleUtils();
  const common = useCommonGaming();
  if (clearState) common.gameStore.clearCompleteState();

  const vertical = await common.$gameService
    .fetchCategories({
      regionCode: common.siteStore.getRegionCode,
      channel: 'WebDesktop',
      count,
      gameCount: count,
      languageCode: getLocale() || 'en-US',
      currency: 'USD',
      ...(freePlayOnly && { freePlayOnly }),
    })
    .then((verticalData) => {
      if (!skipStateUpdate) common.gameStore.setGameStore(verticalData);
      return verticalData;
    })
    .catch((e) => {
      console.error(e);
      return {
        categories: [],
        providers: [],
        themes: [],
      };
    });

  return { ...vertical, loading: false };
};

export const useGetCategory = async ({
  category,
  skip = 0,
  count = 50,
  limit = 50,
}: Partial<
  IGameCategoriesRequest & { skipVertical: boolean }
>): Promise<IGameCategoryResponse> => {
  const common = useCommonGaming();
  const { getLocale } = useLocaleUtils();

  return await common.$gameService.fetchCategory({
    regionCode: common.siteStore.getRegionCode,
    channel: 'WebDesktop',
    skip,
    limit,
    count,
    languageCode: getLocale() || 'en-US',
    category,
    currency: 'USD',
  });
};
